<template>
    <div class="main">
        <h1>Mentions légales</h1>
        <p>Swarovski Crystal Online SA <br>
            Alte Landstrasse 411 <br>
            CH-8708 Männedorf<br>
            Suisse<br>
            <br><br>
            Directeur général : Michele Molon<br>
            <br>
            Inscription au registre du commerce de Zurich<br>
            HRB CHE-101.379.139</p>
        <h2>POUR LES CLIENTS DES ETATS-UNIS :</h2>
        <p>
            Swarovski Digital Business USA Inc.<br>
            Une société basée à Rhode Island<br>
            One Kennedy Drive<br>
            Cranston, Rhode Island 02920 USA<br>
            Représentée par Edward J. Capobianco, Esq.<br><br>

            Numéro d’inscription auprès du Secrétaire d’État du Rhode Island Secretary of State : 000667123<br>
            Numéro d’identification de l’employeur fédéral (Numéro fiscal) : 45-2251132<br>
        </p>

    </div>
</template>

<script>
    export default {
        name: "Mentions"
    }
</script>

<style scoped>

    .main{
        margin: 30px 20%;
        text-align: left;
    }

</style>